import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import {
  NetworkType,
  boardsWithInternalNetwork,
} from '../../../../core/src/shared/enums';
import { useSelector } from '../../store/utils';

type Props = {
  value: NetworkType;
  onChange: (value: NetworkType) => void;
};

export const NetworkTypeSelect = ({ value, onChange }: Props) => {
  const [board] = useSelector(({ variables }) => [variables.BOARD] as const);

  const internalNetworkSupported = boardsWithInternalNetwork.includes(board);

  return (
    <FormControl>
      <InputLabel id="network-type-label">
        <FormattedMessage
          id="settings.service.network_type"
          defaultMessage="Síť"
        />
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as NetworkType)}
        labelId="network-type-label"
        size="medium"
        label={
          <FormattedMessage
            id="settings.service.network_type"
            defaultMessage="Síť"
          />
        }
      >
        {internalNetworkSupported && (
          <MenuItem value={NetworkType.Internal}>
            <FormattedMessage
              id="settings.service.network_type.internal"
              defaultMessage="Interní síť Infigy"
            />
          </MenuItem>
        )}

        {!internalNetworkSupported && (
          <MenuItem value={NetworkType.External}>
            <FormattedMessage
              id="settings.service.network_type.external"
              defaultMessage="Místní síť (zákazníka)"
            />
          </MenuItem>
        )}

        <MenuItem value={NetworkType.Custom}>
          <FormattedMessage
            id="settings.service.network_type.custom"
            defaultMessage="Ruční nastavení adresy"
          />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
